import type { NavigatorDataActions, NavigatorDataState } from "./types";

const INITIAL_STATE: NavigatorDataState = {
  loading: false,
  error: false,
  data: {
    business_main_menu: [],
    personal_main_menu: [],
    about_us: [],
    customer_support: [],
    footer_sitemap: [],
  },
};

export default (
  state: NavigatorDataState = INITIAL_STATE,
  action: NavigatorDataActions
): NavigatorDataState => {
  switch (action.type) {
    case "REQUEST_NAVIGATOR_DATA": {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }
    case "REQUEST_NAVIGATOR_DATA_SUCCESS": {
      return {
        data: action.payload,
        loading: false,
        error: false,
      };
    }
    case "REQUEST_NAVIGATOR_DATA_FAILED": {
      return {
        ...state,
        loading: false,
        error: false,
      };
    }
    default: {
      return state;
    }
  }
};
